import { useMemo } from 'react'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'

const useColumns = () => {
  const columns = useMemo(() => {
    const formatMailboxName = ({ row: { original } }) => {
      const { id, name, email } = original

      return (
        <label htmlFor={id}>
          <span css={text.styles.fontMedium}>{name}</span>
          {email && <span>&nbsp;({email})</span>}
        </label>
      )
    }

    return [
      {
        Header: app.t('Mailboxes'),
        accessor: 'name',
        disableSortBy: true,
        Cell: formatMailboxName,
      },
    ]
  }, [])

  return columns
}

export default useColumns
